import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const GET_REFERRAL = async () => {
  return await fetchUrl({
    url: `${apiUrl}referral`,
    method: 'GET',
    body: {},
  });
};
export const GET_REFERRAL_COUNT = async () => {
  return await fetchUrl({
    url: `${apiUrl}referral/count`,
    method: 'GET',
    body: {},
  });
};
export const GET_REFERRAL_REFFERED = async (page: number, perPage: number) => {
  return await fetchUrl({
    url: `${apiUrl}referral/referred?page=${page}&size=${perPage}`,
    method: 'GET',
    body: {},
  });
};
